export const environment = {
  production: false,
  WebApiUrl: 'https://api-internal.mctradedev.com',
  WeblinkAuthUrl: 'https://auth.mctradedev.com',
  PersonifyIdpDomain: 'https://dev-auth.psfyidp.com',
  IDPBaseUrl: '',
  eCommerceServiceApiBase: 'https://api-internal.mctradedev.com',
  eCommerceServicePort: '',
  financialServiceApiBase: 'https://api-internal.mctradedev.com',
  financialServicePort: '',
  websiteServiceApiBase: 'https://api-internal.mctradedev.com',
  websiteServicePort: '',
  configServiceApiBase: 'https://api-internal.mctradedev.com',
  configServicePort: '',
  profileServiceApiBase: 'https://api-internal.mctradedev.com',
  profileServicePort: '',
  reportServiceApiBase: 'https://api-internal.mctradedev.com',
  reportServicePort: '',
  eventServiceApiBase: 'https://api-internal.mctradedev.com',
  eventServicePort: '',
  userServiceApiBase: 'https://api-internal.mctradedev.com',
  userServicePort: '',
};
